// import Vue from 'vue'
import Investment from './Investment'
import irsCompressor from './irsCompressor'

// const sum_fields = [
//   'intacc',
//   'pending',
//   'value',
//   'ret',
//   'buy',
//   'sell',
//   'income',
// ]
// const stock_fields = [
//   'date',
//   'holding',
//   'price',
//   'price_date',
//   'price_type',
//   'crncyrate',
//   'intacc_loc',
//   'pending_loc',
// ]

class InvestmentAggregation extends Investment {
  compressIrs(){
    let irs = this.investments.map(inv => inv.investment_returns).flat(Infinity)
    this.investment_returns = irsCompressor(irs, this.id)
  }
  // When on a TotalInvestment, we can use the normal investment_returns. This since we dont want Cash investments to 
  compressCashFlowIrs(){
    let irs = this.investments.filter(x => x.type != 'AccountInvestment' && x.type != 'FeeInvestment' && x.type != 'TotalInvestment').map(inv => inv.investment_returns).flat(Infinity)
    this.cf_investment_returns = irsCompressor(irs, this.id)
  }
  get length(){
    return this.flat.length
  }
  get is_minor(){
    return false
  }
  get duplicatedAssetClassAndIssueId(){
    var issue_ids = []
    var dupls = []
    this.flat.forEach((inv)=>{
      let existing = issue_ids.find(id => id[0] === inv.reporting_asset_class && id[1] === inv.issue_id)
      if(existing){
        dupls.push([inv.reporting_asset_class, inv.issue_id])
      } else {
        issue_ids.push([inv.reporting_asset_class, inv.issue_id])
      }
    })
    return [...new Set(dupls.filter(id => id))].sort()
  }
  get flat_until_issueagg(){
    let dupls = this.duplicatedAssetClassAndIssueId
    if(dupls.length == 0){
      return this.flat
    } else {
      return this.flat.filter((inv)=>{
        let existing = dupls.find(id => id[0] === inv.reporting_asset_class && id[1] === inv.issue_id)
        return !(inv.type === 'IssueInvestment' && existing)
      })
    }
  }
}

export default InvestmentAggregation
